import React from 'react';
//import { withTranslation } from 'react-i18next';

class Footer extends React.Component {
    // constructor(props) {
    //   super(props);
    // }
    render() {
      //const { t } = this.props;
      return (
       <>
        <footer className="footer-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 text-center">
                <div className="footer-items mb-5">
                  <a className="navbar-brand" href="index.html">
                    <img src="assets/image/logo.png" alt="" />
                  </a>
                  <div className="copyright-area pt-4">&copy; 2022 caesium, All Rights Reserved </div>
                </div>
                <div id="scroll-to-top" className="scroll-to-top">
                  <a href="#header" className="smooth-anchor">
                    <i className="fa-solid fa-arrow-up"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
       </>
      );
    }
  }

  export default Footer;
  //export default withTranslation()(Footer);